<div style="position:absolute;height:100%;width: 100%;z-index: 2147483647;left:0;top:0;;
                background: rgba(255,255,255,.5);"
    *ngIf="(loading || showSpinner) && !hideSpinner"
    (click)="$event.stopPropagation()">
    <div [ngStyle]="{'left': pageWidthCenter + 'px','position':'absolute','top': pageHeightCenter + 'px'}">
        <mat-progress-spinner class="example-margin"
            [color]="color"
            [mode]="mode"
            [value]="value">
        </mat-progress-spinner>
    </div>
</div>